module.exports = __webpack_public_path__ + "img/WOOCOMMERCE_LARGE.b4004848.svg";